const getSticky = (sticky) => {
  if (typeof sticky === "string") return { [sticky]: 0 };

  return sticky;
};
/**
 * @param {{ left: number } | { right: number } | false} [sticky]
 * @param {number} width
 * */
export default function getCellStyles({ sticky, width }) {
  return {
    width,
    boxSizing: "border-box",
    ...(sticky && { position: "sticky", zIndex: 3, ...getSticky(sticky) }),
  };
}
